module.exports = __webpack_public_path__ + "img/solomon-islands.947a3c13.svg";